import { shouldPolyfill } from '@formatjs/intl-locale/should-polyfill';

export default async function polyfill() {
    if (shouldPolyfill()) {
        // polyfill requirements = Intl.getCanonicalLocales
        await import('./getcanonicallocales');
        await import('@formatjs/intl-locale/polyfill');
    }
}
